import { init as initDrawer } from './drawer';
import { init as initIndicator } from './indicator';
import { getCartMachine } from '../core/cart';
import { activateMachineLogger } from '../core/stent/logger';
import { init as initCartUpsell } from './cart-upsell';
import { init as initCarousel } from './carousel';
//import { init as initCartProgressBar } from './cart-progress-bar'
import { init as initAddFeedback } from './add-to-cart-feedback';
import { init as initGiftnote } from './cart-giftnote';
import { init as initCart } from './cart';
const logErrors = function(err) {
    console.error(err);
};
const machine = getCartMachine();
activateMachineLogger();
machine.init();
initDrawer(machine).catch(logErrors);
initIndicator(machine).catch(logErrors);
//initCartProgressBar().catch(logErrors)
initCartUpsell().catch(logErrors);
initCarousel().catch(logErrors);
initAddFeedback().catch(logErrors);
initGiftnote().catch(logErrors);
initCart().catch(logErrors);
